import { TableCell, TableHead, TableRow } from '@mui/material';
import React, { memo } from 'react';

function DocumentsTableHead() {
  return (
    <TableHead>
      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
        <TableCell sx={{ width: { xs: '200px', sm: '50%' }, minWidth: '150px', fontWeight: 600 }}>
          Folder Name
        </TableCell>
        <TableCell sx={{ width: { xs: '150px', sm: '30%' }, minWidth: '120px', fontWeight: 600 }}>
          Created Date
        </TableCell>
        <TableCell sx={{ width: { xs: '120px', sm: '20%' }, minWidth: '100px', pr: 2, fontWeight: 600 }} align="right">
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export default memo(DocumentsTableHead);
